import type { LicensedFeature } from "@octopusdeploy/octopus-server-client";
import { repository } from "~/clientInstance";

export async function isLicensedFeatureAvailable(licensedFeature: LicensedFeature): Promise<boolean> {
    const enabledFeatures = await repository.Licenses.getFeatures();
    return enabledFeatures && enabledFeatures.EnabledFeatures.findIndex((f) => f === licensedFeature) !== -1;
}
